<template>
  <el-select v-model="view" @change="toggle" placeholder="Select a View">
    <el-option v-for="(option, index) in options"
      :key="index"
      :label="option.text"
      :value="option.value">
    </el-option>
  </el-select>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  props: {
    columns: null,
    trackingSources: null
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      view: ['actions', 'date', 'hours', 'dials', 'contacts', 'listing_nurtures', 'listings_set', 'listings_held', 'listings_taken', 'listings_sold', 'buyer_nurtures', 'buyers_set', 'buyers_held', 'buyers_signed', 'buyser_sold', 'price_correction', 'offers_written'],
      options:[
        { value: ['actions', 'date', 'hours', 'dials', 'contacts', 'listing_nurtures', 'listings_set', 'listings_held', 'listings_taken', 'listings_sold', 'buyer_nurtures', 'buyers_set', 'buyers_held', 'buyers_signed', 'buyser_sold', 'price_correction', 'offers_written'], text: 'Standard View' },
        { value: ['actions', 'date', 'hours', 'dials', 'contacts', 'listing_nurtures', 'listings_set', 'listings_held', 'listings_taken', 'listings_sold'], text: 'Listing Tracking' },
        { value: ['actions', 'date', 'hours', 'dials', 'contacts', 'buyer_nurtures', 'buyers_set', 'buyers_held', 'buyers_signed', 'buyser_sold'], text: 'Buyer Tracking' }
      ]
    }
  },
  methods: {
    toggle() {
      this.columns.filter((column) => {
        column.visible = false
      });

      this.view.forEach((value) => {
        this.columns.filter((column) => {
          if(column.key == value) {
            column.visible = !column.visible;
          }
        });
      });
    },
    addTrackingSources() {
      let sources = [];

      sources.push("actions");

      this.trackingSources.forEach(source => {
        this.options[0].value.push(source.slug);
        sources.push(source.slug);
      });

      this.options.push({
        value: sources,
        text: 'Custom Tracking Sources'
      });
    }
  },
  watch: {
    trackingSources(to, from) {
      this.addTrackingSources();
    }
  }
};
</script>